type NavigationSize = {
  clientWidth: number;
  scrollWidth: number;
};

/**
 * The width the navigation overflowed at, or null while it still fits.
 *
 * Grouping the tabs is the first answer to a crowded navigation. Once even that
 * no longer fits, the overflow spills over the hotel selector beside it and is
 * still clickable there, which is the part worth avoiding.
 *
 * The width is remembered, the way the tab grouping remembers its threshold:
 * acting on the overflow removes it, so without a remembered width whatever we
 * drop would flip straight back on.
 */
export function nextOverflowWidth(
  { clientWidth, scrollWidth }: NavigationSize,
  overflowWidth: number | null,
): number | null {
  if (overflowWidth === null) {
    return scrollWidth > clientWidth ? scrollWidth : null;
  }

  return clientWidth > overflowWidth ? null : overflowWidth;
}
